import { render, staticRenderFns } from "./AccountAddressCreate.vue?vue&type=template&id=10e448a8&"
import script from "./AccountAddressCreate.vue?vue&type=script&lang=js&"
export * from "./AccountAddressCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports